var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { boundMethod } from 'autobind-decorator';
import QueueFromPayload from 'components/powerFlowShared/components/queueFromPayload';
import { FlowNodeTypes, } from 'components/powerFlowShared/components/types';
import { FlowNode, flowNodeColor, NodeTypeComponent, } from 'fable/flowEditor';
import ActionNode from '../../containers/modals/contactform';
export class ContactFormNode extends NodeTypeComponent() {
    triggerEdit() {
        const { onEdit, node } = this.props;
        onEdit(node, node.nodeType);
    }
    render() {
        return (_jsx(FlowNode, { color: ContactFormNode.color, icon: ContactFormNode.icon, label: ContactFormNode.label, text: _jsx(QueueFromPayload, { node: this.props.node }), onEdit: this.triggerEdit }));
    }
}
ContactFormNode.icon = 'chat-widget';
ContactFormNode.label = 'Contact Form';
ContactFormNode.color = flowNodeColor.green;
ContactFormNode.ActionModal = ActionNode;
ContactFormNode.actionTrigger = { type: FlowNodeTypes.CONTACT_FORM };
ContactFormNode.updateConnection = (node) => node;
__decorate([
    boundMethod
], ContactFormNode.prototype, "triggerEdit", null);
